var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7979 2.35227C15.6865 2.2406 15.5542 2.15201 15.4085 2.09156C15.2628 2.03111 15.1067 2 14.9489 2C14.7912 2 14.6351 2.03111 14.4894 2.09156C14.3437 2.15201 14.2114 2.2406 14.1 2.35227L6.12867 10.3236C6.03975 10.4123 5.96919 10.5178 5.92106 10.6338C5.87292 10.7498 5.84814 10.8742 5.84814 10.9999C5.84814 11.1255 5.87292 11.2499 5.92106 11.3659C5.96919 11.482 6.03975 11.5874 6.12867 11.6761L14.1 19.6475C14.57 20.1175 15.3278 20.1175 15.7979 19.6475C16.2679 19.1774 16.2679 18.4196 15.7979 17.9496L8.85293 10.9951L15.8075 4.04054C16.2679 3.5801 16.2679 2.81271 15.7979 2.35227Z",
    fill: "url(#paint0_linear_538_3320)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_3320",
    x1: 5.84814,
    y1: 20,
    x2: 21.3694,
    y2: 11.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628533,
    stopColor: "#F23A3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.70552bc1b92e2eb75e120ce6cdd9e21d.svg";
export { ForwardRef as ReactComponent };